export const INTEGRATION_USER = 'Integration User';

// Labels
export const NOT_APPLICABLE_LABEL = 'N/A';
export const CALIX_SUPPORT_USER_LABEL = 'Calix';

// Calix contact info
export const SUPPORT_EMAIL = 'RMA@calix.com';
export const SUPPORT_PHONE = '(877) 766-3500';
export const SUPPORT_PHONE_CTA = '+18777663500,8';
export const CUSTOMER_OPERATIONS_EMAIL = 'calixcustomerops@calix.com';

// External URLs
export const CART_URL = '/cart';
export const SEARCH_URL = '/search';
export const CART_NEW_URL = '/cart/new';
export const QUOTE_LIST_URL = '/quote-list';
export const ACCOUNT_SEARCH_URL = '/account-search';
export const ORDER_MANAGER_URL = '/order-manager/orders';

// URL query params
export const CLONE_FROM_PARAM = 'cloneFrom';
export const NEW_CASE_PARAM = 'newCase';

// Statuses
export const UNKNOWN_STATUS = 'Unknown';
export const REVIEW_STATUS = 'ReviewNeeded';
export const IN_WARRANTY_STATUS = 'InWarranty';
export const OUT_OF_WARRANTY_STATUS = 'OutOfWarranty';
export const INVALID_CONTRACT_STATUS = 'InvalidContract';
export const DIFFERENT_ACCOUNT_STATUS = 'DifferentAccount';
export const RMA_FORBIDDEN_STATUS = 'RmaForbiddenForPart';
export const PART_NOT_ELIGIBLE_STATUS = 'PartNotEligibleForWarranty';
export const RMA_SCRAPPED_STATUS = 'RmaSerialNumberScrapped';

//Error Codes
export const CASE_SUBMIT_ERROR = {
  UNABLE_TO_LOCK_ERROR_CODE: 1,
};

// Shipping
export const STANDARD_SHIPPING_METHOD = 'Standard';
export const ADVANCE_SHIPPING_METHOD = 'AdvanceExchange';
export const EXPEDITE_SHIPPING_METHOD = 'ExpediteExchange';
export const BILL_TO_COUNTRY_US = 'US';
export const BILL_TO_COUNTRY_CA = 'CA';
export const SHIPPING_AMERICAS_ADVANCE_PRICE = 245;
export const SHIPPING_INTERNATIONAL_ADVANCE_PRICE = 345;
export const SHIPPING_AMERICAS_EXPEDITE_PRICE = 395;
export const SHIPPING_INTERNATIONAL_EXPEDITE_PRICE = 495;

// Graphql operation names
export const GET_ACCOUNT_OPERATION = 'GetAccount';
export const GET_ADDRESSES_OPERATION = 'GetAddresses';
export const GET_PRODUCT_OPERATION = 'GetProduct';
export const LIST_ALL_RMA_CASES_OPERATION = 'ListAllRmaCases';
export const GET_RMA_CASE_OPERATION = 'GetRmaCase';
export const GET_RMA_ORDER_OPERATION = 'GetRmaOrder';
export const GET_COMMENTS_OPERATION = 'GetComments';
export const CHECK_WARRANTY_STATUS_OPERATION = 'CheckWarrantyStatus';
export const UNFAVORITE_ADDRESS_OPERATION = 'UnfavoriteAddress';
export const CREATE_ADDRESS_OPERATION = 'CreateAddress';
export const CREATE_COMMENT_OPERATION = 'CreateComment';
export const ADD_ATTACHMENTS_TO_CASE_OPERATION = 'AddAttachmentsToCase';
export const CREATE_CASE_OPERATION = 'CreateCase';
export const SEND_CONTACT_MESSAGE_OPERATION = 'SendContactMessage';
export const SEND_FEEDBACK_OPERATION = 'SendFeedback';

// Customer-based actions
export const LOOKUP_UI_INITIAL_STATE = 'Initial';
export const LOOKUP_UI_INCORRECT_PART_STATE = 'IncorrectPart';
export const LOOKUP_UI_MULTIPLE_PARTS_STATE = 'MultipleParts';
export const LOOKUP_UI_OOW_WITHOUT_PRICE_STATE = 'NoRepairFee';

// API Response derived statuses
export const LOOKUP_UI_SN_NOT_FOUND_STATE = UNKNOWN_STATUS;
export const LOOKUP_UI_INVALID_CONTRACT_STATE = INVALID_CONTRACT_STATUS;
export const LOOKUP_UI_IN_WARRANTY_STATE = IN_WARRANTY_STATUS;
export const LOOKUP_UI_OUT_OF_WARRANTY_STATE = OUT_OF_WARRANTY_STATUS;
export const LOOKUP_UI_DIFFERENT_ACCOUNT_STATE = DIFFERENT_ACCOUNT_STATUS;
export const LOOKUP_UI_PART_NOT_ELIGIBLE_STATE = PART_NOT_ELIGIBLE_STATUS;
export const LOOKUP_UI_RMA_FORBIDDEN_STATE = RMA_FORBIDDEN_STATUS;
export const LOOKUP_UI_RMA_SCRAPPED_STATE = RMA_SCRAPPED_STATUS;

export const LOOKUP_UI_STATE_MAP = {
  [UNKNOWN_STATUS]: LOOKUP_UI_SN_NOT_FOUND_STATE,
  [IN_WARRANTY_STATUS]: LOOKUP_UI_IN_WARRANTY_STATE,
  [INVALID_CONTRACT_STATUS]: LOOKUP_UI_INVALID_CONTRACT_STATE,
  [OUT_OF_WARRANTY_STATUS]: LOOKUP_UI_OUT_OF_WARRANTY_STATE,
  [DIFFERENT_ACCOUNT_STATUS]: LOOKUP_UI_DIFFERENT_ACCOUNT_STATE,
  [PART_NOT_ELIGIBLE_STATUS]: LOOKUP_UI_PART_NOT_ELIGIBLE_STATE,
  [RMA_FORBIDDEN_STATUS]: LOOKUP_UI_RMA_FORBIDDEN_STATE,
  [RMA_SCRAPPED_STATUS]: LOOKUP_UI_RMA_SCRAPPED_STATE,
};

// Constraints
export const MAXIMUM_NO_OF_ATTACHMENTS_PER_COMMENT = 5;
export const MAXIMUM_ATTCHMENT_SIZE = 3670016; // 3.5MB in binary
export const MAXIMUM_NO_OF_ITEMS_ON_CASE = 30;
export const MAXIMUM_NO_OF_ITEMS_ON_CASE_MESSAGE =
  'You have reached the maximum number of items on your case. If you need to add more items, please submit a separate RMA Case.';

// Checkout
export const CHECKOUT_SHIPPING_STEP = 'shipping';
export const CHECKOUT_BILLING_STEP = 'billing';
export const CHECKOUT_REVIEW_STEP = 'review';
export const CHECKOUT_CONFIRMATION_STEP = 'confirmation';
export const CHECKOUT_STEP_SEQUENCE = [
  CHECKOUT_SHIPPING_STEP,
  CHECKOUT_BILLING_STEP,
  CHECKOUT_REVIEW_STEP,
  CHECKOUT_CONFIRMATION_STEP,
];

// Case types
export const SERVICE_ADM_CASE_TYPE = 'Service Administration';

// Addresses
export const ADDRESS_SHIPPING_TYPE = 'shipTo';
export const ADDRESS_BILLING_TYPE = 'billTo';
export const ADDRESS_BOTH_TYPE = 'both';

// Countries
export const COUNTRY_USA = 'United States';
export const COUNTRY_CANADA = 'Canada';

// Bugsnag
export const BUGSNAG_GRAPHQL_IGNORED_OPERATIONS = [GET_ACCOUNT_OPERATION];
export const BUGSNAG_NETWORK_IGNORED_OPERATIONS = [];
export const BUGSNAG_ERROR_CLASSES = {
  DEFAULT_ERROR: 'Error',
  SPINNER_TIMEOUT: 'Spinner limit reached',
  USER_ERROR: 'User Error',
  USER_UNAUTHORIZED: 'User Unauthorized',
  USER_WITHOUT_ACCESSES: 'User Without Store Access',
  USER_WITHOUT_PROPER_ACCESS: 'User Without RMA Access',
  GRAPHQL_ERROR: 'GraphQL Error',
  GRAPHQL_NETWORK_ERROR: 'GraphQL Network Error',
  CASE_CREATED: 'Case Created',
};

// Matches a string that has content AND has characters other than whitespaces
export const NOT_BLANK_REGEX = /^(?!\s+$).+/;

// Cookie names
export const LOGGED_IN_JWT_COOKIE = 'LoggedInUserEcommJWT';
export const USER_REQUEST_PATH_COOKIE = 'user_request_path';

//validation part-number
export const RMA_PART_PREFIX_REGEX = /^[1][02][0]/;
export const PART_NUMBER_REGEX = /^[1][02][0][-][0-9][0-9][0-9][0-9][0-9]/;

// Message for repair fee not allowed
export const FEE_NOT_ALLOWED_MESSAGE =
  'You can not proceed with this action because there is a cost associated with this RMA request.  Your user account does not have permission to submit RMA requests that have a cost associated with them.  Please contact the RMA department if you have any questions.';

//Message for total price in header
export const HEADER_TOTAL_MESSAGE = 'Total only reflects values upon submission of the case.';
